import React from 'react'
import TimeAgo from 'react-timeago'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'

class CommentItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isDel: false,
            isModi: false,
            isRep: false,
            cmtTxt: this.props.data.message ? this.props.data.message : '',
        }
    }

    chkTextValue = () => e => {
        this.setState({ cmtTxt: e.target.value })
    }

    dateSlice = d => {
        const ddd = d.split(' ')
        const da = ddd[0].split('-')
        const ti = ddd[1].split(':')
        const dd = new Date(da[0], da[1] - 1, da[2], ti[0], ti[1], ti[2])
        let interval = new Date().getTime() - new Date(dd).getTime()
        interval = Math.floor(interval / 86400000)
        if (interval > 6) {
            const dt = d.split(' ')
            return dt[0]
        }
        const formatter = buildFormatter({
            suffixAgo: ' 전',
            seconds: '방금',
            minute: '1분',
            minutes: '%d분',
            hour: '1시간',
            hours: '%d시간',
            day: '1일',
            days: '%d일',
            week: '1주',
        })
        return <TimeAgo date={dd} formatter={formatter} />
    }

    delCmt = () => {
        this.props.delCmt(this.props.data.idx_threads)
    }

    setBtn = (cls, fnc, txt) => {
        return (
            <button className={cls} type="button" onClick={() => this.setState(fnc)}>
                {txt}
            </button>
        )
    }

    postCmt = () => {
        this.setState({ isModi: false, isRep: false })
        const cnums = this.state.isRep ? [null, this.props.data.idx_threads] : [this.props.data.idx_threads, null]
        this.props.postCmt(cnums[0], this.state.cmtTxt, cnums[1])
    }

    render() {
        const { data, user, isRep } = this.props
        const ismy = user.user_idx === data.idx_member ? [data.nm_nick, true] : [data.nm_nick, false]
        ismy[0] =
            data.idx_b_manager === 1 ? (
                <p className="isPping">
                    <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/v5/comm/mlogo.png`} alt="logo" />{' '}
                    {data.mall_name}
                </p>
            ) : (
                <strong>{ismy[0]}</strong>
            )
        const isdis = !(this.state.cmtTxt.length > 10 && this.state.cmtTxt.length < 1000)
        return (
            <tr>
                <td>{ismy[0]}</td>
                <td className={`is${isRep}`}>
                    {this.state.isModi ? (
                        <div className="commentWrap_icmnt">
                            <div className="commentWrap_icmnt_form">
                                <div className="itextarea">
                                    <textarea
                                        name="comment"
                                        placeholder="※ 광고/욕설/비방이나 목적에 맞지 않는 글은 관리자에 의해 삭제될 수 있습니다.(10자 이상 등록 가능합니다.)"
                                        defaultValue={this.props.data.message}
                                        onKeyUp={this.chkTextValue()}
                                    />
                                </div>
                                <div className="commentWrap_icmnt_form_bot">
                                    <span className="icheck">
                                        <input type="checkbox" defaultChecked={data.f_stat === 1} disabled />
                                        <label className="chk" htmlFor="block">
                                            비밀글
                                            <input type="hidden" />
                                        </label>
                                        <font className="clrbase3">&nbsp;비밀/공개 여부는 수정되지 않습니다.</font>
                                    </span>
                                    <div className="isubmit">
                                        <span className="word-cnt">
                                            <em className="clrpont3">{this.state.cmtTxt.length}</em> / 1,000
                                        </span>
                                        <button
                                            type="button"
                                            className="cmntSubmit cancleBtn"
                                            onClick={() => this.setState({ isModi: false, cmtTxt: '' })}
                                        >
                                            취소
                                        </button>
                                        <button
                                            type="button"
                                            className="cmntSubmit"
                                            disabled={isdis}
                                            onClick={this.postCmt}
                                        >
                                            등록
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <React.Fragment>
                            <div className="itemCon">
                                {this.props.data.f_stat === 0 || ismy[1] || user.user_auth === 4 ? (
                                    this.props.data.message
                                ) : (
                                    <span className="clrbase3"> = = = 비밀글 입니다. = = = </span>
                                )}
                                {this.state.isRep && (
                                    <div className="commentWrap_icmnt">
                                        <div className="commentWrap_icmnt_form">
                                            <div className="itextarea">
                                                <textarea
                                                    name="comment"
                                                    placeholder="※ 광고/욕설/비방이나 목적에 맞지 않는 글은 관리자에 의해 삭제될 수 있습니다.(10자 이상 등록 가능합니다.)"
                                                    defaultValue=""
                                                    onKeyUp={this.chkTextValue()}
                                                />
                                            </div>
                                            <div className="commentWrap_icmnt_form_bot">
                                                <span className="icheck">
                                                    <input
                                                        type="checkbox"
                                                        defaultChecked={data.f_stat === 1}
                                                        disabled
                                                    />
                                                    <label className="chk" htmlFor="block">
                                                        <input type="hidden" />
                                                        비밀글
                                                    </label>
                                                    &nbsp;비밀/공개 여부를 설정 할 수 없습니다.
                                                </span>
                                                <div className="isubmit">
                                                    <span className="word-cnt">
                                                        <em className="clrpont3">{this.state.cmtTxt.length}</em> / 1,000
                                                    </span>
                                                    <button
                                                        type="button"
                                                        className="cmntSubmit cancleBtn"
                                                        onClick={() => this.setState({ isRep: false, cmtTxt: '' })}
                                                    >
                                                        취소
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="cmntSubmit"
                                                        disabled={isdis}
                                                        onClick={this.postCmt}
                                                    >
                                                        등록
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {this.props.user.user_idx > 0 && (
                                <React.Fragment>
                                    {ismy[1] ? (
                                        <div className="cmntItemBtns">
                                            {this.state.isDel ? (
                                                <span className="delete">
                                                    <font>정말 삭제하시겠습니까?</font>
                                                    <button
                                                        type="button"
                                                        className="clrpont3 styNor"
                                                        onClick={this.delCmt}
                                                    >
                                                        예
                                                    </button>
                                                    <font>│</font>
                                                    {this.setBtn('clrbase3 styNor', { isDel: false }, '아니요')}
                                                </span>
                                            ) : (
                                                !this.state.isModi &&
                                                !this.state.isRep && (
                                                    <span className="modify">
                                                        {this.setBtn(
                                                            'clrbase3',
                                                            { isModi: true, cmtTxt: this.props.data.message },
                                                            '수정',
                                                        )}
                                                        <font className="clrbase3">│</font>
                                                        {this.setBtn('clrbase3', { isDel: true }, '삭제')}
                                                    </span>
                                                )
                                            )}
                                        </div>
                                    ) : (
                                        <div className="cmntItemBtns">
                                            <span className="modify">
                                                {this.props.isRep === 'tar' &&
                                                    !this.state.isRep &&
                                                    this.props.user.user_auth === 4 &&
                                                    this.setBtn('clrbase3', { isRep: true, cmtTxt: '' }, '답글')}
                                            </span>
                                        </div>
                                    )}
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                </td>
                <td>{this.dateSlice(this.props.data.dt_reg)}</td>
            </tr>
        )
    }
}
export default CommentItem
